'use client';
import React from 'react';
import { CreditCard } from 'lucide-react';
import Header from '@/components/landing/Header';
import Footer from '@/components/landing/Footer';
import CTASection from '@/components/landing/CTASection';
import FAQSection, { type FAQCategory } from '@/components/landing/FAQSection';
import Pricing from '@/components/landing/Pricing';

/* Billing-specific questions, rendered through the shared FAQSection so this
   page matches the home page's accordion instead of carrying its own. A single
   category means the component drops its tab rail and centres the list. */
const PRICING_FAQ: FAQCategory[] = [
  {
    id: 'billing',
    label: 'Billing',
    icon: CreditCard,
    items: [
      {
        question: 'Can I switch plans later?',
        answer: 'Absolutely. You can upgrade or downgrade your plan at any time. Prorated charges will be applied automatically to your next billing cycle.'
      },
      {
        question: 'Is there a setup fee?',
        answer: 'No, there are no hidden setup fees or onboarding costs. You only pay the flat monthly or annual rate.'
      },
      {
        question: 'How does data migration work?',
        answer: 'Our onboarding team will help you migrate your existing student, staff, and financial records via secure Excel/CSV imports completely free of charge.'
      }
    ],
  },
];

export default function PricingPage() {
  return (
    <div className="landing-root min-h-screen bg-[#FAFCFF] font-roboto overflow-x-hidden" data-testid="pricing-page-root">
      <Header />

      <main className="pt-12 sm:pt-16 lg:pt-[76px] relative" data-testid="pricing-main">
        {/* Dynamic Pricing Component from Admin Panel */}
        <Pricing />

        <FAQSection
          heading={<>Pricing questions, <span className="section-heading-accent">answered.</span></>}
          categories={PRICING_FAQ}
        />
      </main>
      <CTASection />
      <Footer />
    </div>
  );
}
